export const serverUrl = "https://comma-messenger.onrender.com";
export const apiBasePath = "/api/rest/v1";
